import "core-js/modules/es.array.concat";
import "regenerator-runtime/runtime";

var _marked =
/*#__PURE__*/
regeneratorRuntime.mark(inviteAFriendOnEnter);

import { select, call, put } from 'redux-saga/effects';
import { fetchEntityIfNeeded } from '@classpass/saga-tools';
import { userActionCampaign } from 'redux/saga/entities/bound';
import { isLoggedIn } from 'redux/saga/selectors/user';
import { deepExtract } from 'helpers/deep';
import { loadInviteAFriendError } from './InviteAFriend.saga';
export function inviteAFriendOnEnter(client, nextState, replaceState) {
  var finalDestination, loggedIn, token, _ref, schedule, studioAlias, classAlias;

  return regeneratorRuntime.wrap(function inviteAFriendOnEnter$(_context) {
    while (1) {
      switch (_context.prev = _context.next) {
        case 0:
          finalDestination = '/search';
          _context.next = 3;
          return select(isLoggedIn);

        case 3:
          loggedIn = _context.sent;
          token = deepExtract('params.token', nextState);

          if (!(loggedIn && !token)) {
            _context.next = 9;
            break;
          }

          _context.next = 8;
          return call(replaceState, finalDestination);

        case 8:
          return _context.abrupt("return", _context.sent);

        case 9:
          _context.prev = 9;
          _context.next = 12;
          return call(fetchEntityIfNeeded, userActionCampaign, [client, token], {
            key: token
          });

        case 12:
          _ref = _context.sent;
          schedule = _ref.schedule;

          if (!loggedIn) {
            _context.next = 20;
            break;
          }

          studioAlias = deepExtract('venue.alias', schedule);
          classAlias = deepExtract('class.alias', schedule);
          finalDestination = "/studios/".concat(studioAlias, "/").concat(classAlias, "/").concat(schedule.id);
          _context.next = 20;
          return call(replaceState, finalDestination);

        case 20:
          _context.next = 31;
          break;

        case 22:
          _context.prev = 22;
          _context.t0 = _context["catch"](9);

          if (!loggedIn) {
            _context.next = 29;
            break;
          }

          _context.next = 27;
          return call(replaceState, finalDestination);

        case 27:
          _context.next = 31;
          break;

        case 29:
          _context.next = 31;
          return put(loadInviteAFriendError(_context.t0));

        case 31:
        case "end":
          return _context.stop();
      }
    }
  }, _marked, null, [[9, 22]]);
}